const NavigationItems = [
    {"label": "About", "id": "about"},
    {"label": "Services", "id": "services"},
    // {"label": "Team", "id": "team"},
    {"label": "Careers", "id": "careers"},
    {"label": "Contact", "id": "contact"}
];

export default NavigationItems;
